import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

export default function StimulusPicker({ stimuli = [], value, onChange, className }) {
  const { t } = useTranslation();
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className={cn(
        'w-full px-3 py-2 rounded-lg text-sm',
        'bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600',
        'text-gray-900 dark:text-white',
        'focus:outline-none focus:border-gray-400 dark:focus:border-gray-500',
        'transition-all duration-200',
        className
      )}
    >
      <option value="">{t('questions.noStimulus')}</option>
      {stimuli.map((s) => (
        <option key={s.id} value={s.id}>
          {s.title || `${s.stimulus_type} stimulus`}
        </option>
      ))}
    </select>
  );
}
